module.exports = __webpack_public_path__ + "img/Perfil.512ff897.png";